// react imports
import React, { useContext, useState, useEffect } from "react";
import { Outlet, useSearchParams, useNavigate } from "react-router-dom";

import AppContext from "../../AppContext";

import top from "../../assets/media/images/top.png";
import hamburger from "../../assets/media/icons/hamburgermenu.png";
// MDBOOTSTRAP IMPORTS
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBSideNav,
  MDBSideNavMenu,
  MDBSideNavItem,
  MDBSideNavLink,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBSideNavCollapse,
  MDBIcon,
  MDBBtn,
  MDBRow,
  MDBInput,
  MDBCol,
} from "mdb-react-ui-kit";

// IMPORT LAYOUT COMPONENTS
import Cookies from "universal-cookie";
const cookies = new Cookies();

function Header({ children }) {
  const context = useContext(AppContext);

  // STATES
  const [basicOpen, setBasicOpen] = useState(false);
  const [basicCollapse1, setBasicCollapse1] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  // react router navigation
  const navigate = useNavigate();

  useEffect(() => {
    document.addEventListener("scroll", scrollEventListener);

    return () => {
      document.removeEventListener("scroll", scrollEventListener);
    };
  }, []);

  const scrollEventListener = () => {
    if (window.scrollY < 50) {
      setIsScrolling(false);
    } else {
      setIsScrolling(true);
    }
  };

  return (
    <>
      <div className="header-image">
        <img src={top} alt="" />
        <div className="header-div">
          <span>+36307494358</span>
        </div>
      </div>
      <MDBNavbar
        expand="lg"
        sticky
        light
        bgColor="light"
        className={!isScrolling ? "navbar-bottom d-none d-lg-block" : "navbar-bottom iscrolling d-none d-lg-block"}
      >
        <MDBContainer fluid className="d-flex justify-content-start align-items-center" style={{ height: "100%" }}>
          <div className="navitem-padding">
            <MDBNavbarItem
              onClick={() => {
                context.onSetActiveItem("1");
                navigate("/home");
              }}
            >
              <MDBNavbarLink active={context.getState()?.activeItem === "1"}>Kezdőlap</MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem
              onClick={() => {
                context.onSetActiveItem("2");
                navigate("/content", {
                  state: {
                    filename: "szabalyzat",
                  },
                });
              }}
            >
              <MDBNavbarLink active={context.getState()?.activeItem === "2"}>Tó szabályzata</MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem
              onClick={() => {
                context.onSetActiveItem("3");
                navigate("/content", {
                  state: {
                    filename: "hazirend",
                  },
                });
              }}
            >
              <MDBNavbarLink active={context.getState()?.activeItem === "3"}>Faház - házirend</MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem
              onClick={() => {
                context.onSetActiveItem("4");
                navigate("/content", {
                  state: {
                    filename: "arlista",
                  },
                });
              }}
            >
              <MDBNavbarLink active={context.getState()?.activeItem === "4"}>Árak</MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem
              onClick={() => {
                context.onSetActiveItem("5");
                navigate("/content", {
                  state: {
                    filename: "bufe",
                  },
                });
              }}
            >
              <MDBNavbarLink active={context.getState()?.activeItem === "5"}>Büfé</MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem
              onClick={() => {
                context.onSetActiveItem("6");
                navigate("/content", {
                  state: {
                    filename: "horgaszbolt",
                  },
                });
              }}
            >
              <MDBNavbarLink active={context.getState()?.activeItem === "6"}>Horgászbolt</MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem
              onClick={() => {
                context.onSetActiveItem("7");
                navigate("/content", {
                  state: {
                    filename: "berles",
                  },
                });
              }}
            >
              <MDBNavbarLink active={context.getState()?.activeItem === "7"}>Bérlési lehetőségek</MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem
              onClick={() => {
                context.onSetActiveItem("8");
                navigate("/galerypage");
              }}
            >
              <MDBNavbarLink active={context.getState()?.activeItem === "8"}>Galéria</MDBNavbarLink>
            </MDBNavbarItem>
            <MDBNavbarItem
              onClick={() => {
                context.onSetActiveItem("9");
                navigate("/kapcsolat");
              }}
            >
              <MDBNavbarLink active={context.getState()?.activeItem === "9"}>Kapcsolat</MDBNavbarLink>
            </MDBNavbarItem>
          </div>
        </MDBContainer>
      </MDBNavbar>

      <div className=" d-block d-lg-none navbar-side">
        <div className="sidenav-bottom-respo">
          <MDBRow className="m-0 p-0" style={{ width: "100%", height: "100%" }}>
            <MDBCol md="3" sm="3" size="3" className="d-flex justify-content-start align-items-center ps-4">
              <MDBBtn onClick={() => setBasicOpen(!basicOpen)} className="sidenavButton">
                <MDBIcon fas icon="bars" color="info" size="3x" />
              </MDBBtn>
            </MDBCol>
            <MDBCol md="9" sm="9" size="9" className="d-flex align-items-center justify-content-start  pe-3">
              <div className="d-flex justify-content-end align-items-center title-text" style={{ width: "100%" }}></div>
            </MDBCol>
          </MDBRow>
        </div>
        <MDBSideNav isOpen={basicOpen} mode="side" absolute getOpenState={(e) => setBasicOpen(e)}>
          <MDBSideNavMenu>
            <MDBRow className="m-0 pb-5" style={{ width: "100%", height: "100%" }}>
              <MDBCol className="d-flex justify-content-start align-items-center ps-4 pb-5">
                <MDBBtn onClick={() => setBasicOpen(!basicOpen)} className="sidenavButton-2"></MDBBtn>
              </MDBCol>
            </MDBRow>
            <MDBSideNavItem
              onClick={() => {
                setBasicOpen(!basicOpen);
                context.onSetActiveItem("1");
                navigate("/home");
              }}
            >
              <MDBSideNavLink active={context.getState()?.activeItem === "1"}>Kezdőlap</MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem
              onClick={() => {
                setBasicOpen(!basicOpen);
                context.onSetActiveItem("2");
                navigate("/content", {
                  state: {
                    filename: "szabalyzat",
                  },
                });
              }}
            >
              <MDBSideNavLink active={context.getState()?.activeItem === "2"}>Tó szabályzata</MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem
              onClick={() => {
                setBasicOpen(!basicOpen);
                context.onSetActiveItem("3");
                navigate("/content", {
                  state: {
                    filename: "hazirend",
                  },
                });
              }}
            >
              <MDBSideNavLink active={context.getState()?.activeItem === "3"}>Faház - házirend</MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem
              onClick={() => {
                setBasicOpen(!basicOpen);
                context.onSetActiveItem("4");
                navigate("/content", {
                  state: {
                    filename: "arlista",
                  },
                });
              }}
            >
              <MDBSideNavLink active={context.getState()?.activeItem === "4"}>Árak</MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem
              onClick={() => {
                setBasicOpen(!basicOpen);
                context.onSetActiveItem("5");
                navigate("/content", {
                  state: {
                    filename: "bufe",
                  },
                });
              }}
            >
              <MDBSideNavLink active={context.getState()?.activeItem === "5"}>Büfé</MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem
              onClick={() => {
                setBasicOpen(!basicOpen);
                context.onSetActiveItem("6");
                navigate("/content", {
                  state: {
                    filename: "horgaszbolt",
                  },
                });
              }}
            >
              <MDBSideNavLink active={context.getState()?.activeItem === "6"}>Horgászbolt</MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem
              onClick={() => {
                setBasicOpen(!basicOpen);
                context.onSetActiveItem("7");
                navigate("/content", {
                  state: {
                    filename: "berles",
                  },
                });
              }}
            >
              <MDBSideNavLink active={context.getState()?.activeItem === "7"}>Bérlési lehetőségek</MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem
              onClick={() => {
                setBasicOpen(!basicOpen);
                context.onSetActiveItem("8");
                navigate("/galery");
              }}
            >
              <MDBSideNavLink active={context.getState()?.activeItem === "8"}>Galéria</MDBSideNavLink>
            </MDBSideNavItem>
            <MDBSideNavItem
              onClick={() => {
                setBasicOpen(!basicOpen);
                context.onSetActiveItem("9");
                navigate("/kapcsolat");
              }}
            >
              <MDBSideNavLink active={context.getState()?.activeItem === "9"}>Kapcsolat</MDBSideNavLink>
            </MDBSideNavItem>
          </MDBSideNavMenu>
        </MDBSideNav>
      </div>
    </>
  );
}

export default Header;
